// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("./MM_parser.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("./MM_context.bs.js");

function extractVarToRecIdxMapping(args, frame) {
  var varToRecIdxMapping = new Array(frame.numOfVars);
  var locks = Belt_Array.make(frame.numOfVars, false);
  if (args.length !== frame.numOfArgs) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "extractVarToRecIdxMapping: args.Js_array2.length != frame.numOfArgs"
          },
          Error: new Error()
        };
  }
  frame.hyps.forEach(function (hyp, i) {
        if (hyp.typ !== /* F */0) {
          return ;
        }
        var v = Caml_array.get(hyp.expr, 1);
        if (Caml_array.get(locks, v)) {
          throw {
                RE_EXN_ID: MM_parser.MmException,
                _1: {
                  msg: "extractVarToRecIdxMapping: locks[v]"
                },
                Error: new Error()
              };
        }
        Caml_array.set(locks, v, true);
        Caml_array.set(varToRecIdxMapping, v, Caml_array.get(args, i));
      });
  if (locks.some(function (lock) {
          return !lock;
        })) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "extractVarToRecIdxMapping: locks->Js_array2.some(lock => !lock)"
          },
          Error: new Error()
        };
  }
  return varToRecIdxMapping;
}

function buildSyntaxTreeInner(idSeq, ctx, tbl, parent, r) {
  var match = r.proof;
  if (match.TAG === /* Hypothesis */0) {
    var maxI = r.expr.length - 1 | 0;
    var children = new Array(maxI);
    for(var i = 1; i <= maxI; ++i){
      Caml_array.set(children, i - 1 | 0, {
            TAG: /* Symbol */1,
            id: Curry._1(idSeq, undefined),
            sym: MM_context.ctxIntToSymExn(ctx, Caml_array.get(r.expr, i))
          });
    }
    return {
            id: Curry._1(idSeq, undefined),
            parent: parent,
            label: match.label,
            children: children
          };
  }
  var label = match.label;
  var frame = MM_context.getFrame(ctx, label);
  if (frame !== undefined) {
    var varToRecIdxMapping = extractVarToRecIdxMapping(match.args, frame);
    var this_id = Curry._1(idSeq, undefined);
    var this_children = new Array(frame.asrt.length - 1 | 0);
    var $$this = {
      id: this_id,
      parent: parent,
      label: label,
      children: this_children
    };
    frame.asrt.forEach(function (s, i) {
          if (i > 0) {
            return Caml_array.set(this_children, i - 1 | 0, s < 0 ? ({
                            TAG: /* Symbol */1,
                            id: Curry._1(idSeq, undefined),
                            sym: MM_context.ctxIntToSymExn(ctx, s)
                          }) : ({
                            TAG: /* Subtree */0,
                            _0: buildSyntaxTreeInner(idSeq, ctx, tbl, $$this, Caml_array.get(tbl, Caml_array.get(varToRecIdxMapping, s)))
                          }));
          }
          
        });
    return $$this;
  }
  throw {
        RE_EXN_ID: MM_parser.MmException,
        _1: {
          msg: "Cannot find a frame by label '" + label + "'"
        },
        Error: new Error()
      };
}

function buildSyntaxTree(ctx, tbl, targetIdx) {
  var nextId = {
    contents: 0
  };
  var idSeq = function (param) {
    nextId.contents = nextId.contents + 1 | 0;
    return String(nextId.contents - 1 | 0);
  };
  return buildSyntaxTreeInner(idSeq, ctx, tbl, undefined, Caml_array.get(tbl, targetIdx));
}

function syntaxTreeToSymbols(node) {
  return Belt_Array.concatMany(node.children.map(function (childNode) {
                  if (childNode.TAG === /* Subtree */0) {
                    return syntaxTreeToSymbols(childNode._0);
                  } else {
                    return [childNode.sym];
                  }
                }));
}

function syntaxTreeIsEmpty(node) {
  return node.children.length === 0;
}

exports.buildSyntaxTree = buildSyntaxTree;
exports.syntaxTreeToSymbols = syntaxTreeToSymbols;
exports.syntaxTreeIsEmpty = syntaxTreeIsEmpty;
/* MM_context Not a pure module */
